/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_My_Account_Delete_AccountInputs */

const en_shell_my_account_delete_account = /** @type {(inputs: Shell_My_Account_Delete_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Account`)
};

const es_shell_my_account_delete_account = /** @type {(inputs: Shell_My_Account_Delete_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

const ar_shell_my_account_delete_account = /** @type {(inputs: Shell_My_Account_Delete_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف الحساب`)
};

/**
* | output |
* | --- |
* | "Delete Account" |
*
* @param {Shell_My_Account_Delete_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const shell_my_account_delete_account = /** @type {((inputs?: Shell_My_Account_Delete_AccountInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_My_Account_Delete_AccountInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shell_my_account_delete_account(inputs)
	if (locale === "es") return es_shell_my_account_delete_account(inputs)
	return ar_shell_my_account_delete_account(inputs)
});